import React from 'react';
import SelectionItem from '../selectionitem/SelectionItem';
import Link from '../link/Link'
import * as styles from './Selection.css';
import koskiImg from 'Static/img/opintoni_white.svg';
import valpasImg from 'Static/img/opintoni_white.svg';
import vardaImg from 'Static/img/opintoni_white.svg';
import ykiImg from 'Static/img/opintoni_white.svg';
import hakemukseniImg from 'Static/img/hakemukseni_white.svg';
import viestiniImg from 'Static/img/hakemukseni_white.svg';
import tietojenikayttoImg from 'Static/img/tietojenikaytto.svg';
import { createYkiAsiakasportaaliLink } from '../../utils';

const Selection = ({isLoggedIn, usingValtuudet}) => (
  <React.Fragment>
    <div className={styles['flex-container']}>
      <SelectionItem isLoggedIn={isLoggedIn} disableForValtuudet={usingValtuudet} namespace='hakemukseni' icon={hakemukseniImg} link='/oma-opiskelijavalinta' />
      <SelectionItem isLoggedIn={isLoggedIn} disableForValtuudet={usingValtuudet} namespace='koski' icon={koskiImg} link='/koski/omattiedot' />
      <SelectionItem isLoggedIn={isLoggedIn} disableForValtuudet={usingValtuudet} namespace='yki' icon={ykiImg} link={createYkiAsiakasportaaliLink()} />
      <SelectionItem isLoggedIn={isLoggedIn} disableForValtuudet={false} namespace='varda' icon={vardaImg} link='/varda' />
      <SelectionItem isLoggedIn={isLoggedIn} disableForValtuudet={usingValtuudet} namespace='ehoks' icon={koskiImg} link='/ehoks' />
      <SelectionItem isLoggedIn={isLoggedIn} disableForValtuudet={usingValtuudet} namespace='valpas' icon={valpasImg} link='/valpas' />
      <SelectionItem isLoggedIn={isLoggedIn} disableForValtuudet={usingValtuudet} namespace='viestini' icon={viestiniImg} link='/omat-viestit/' />
    </div>
    <div className={styles['bottom-container']}>
      {!usingValtuudet
        ? <Link isLoggedIn={isLoggedIn} namespace='tietojenikaytto' icon={tietojenikayttoImg} link='/koski/omadata/kayttooikeudet' />
        : null}
    </div>
  </React.Fragment>
);

export default Selection;
